import { mutator } from 'satcheljs';
import {
    setQuickComposeActivePivot,
    updateCachedEventData,
    setQuickComposeEventBodyViewState,
    updateOofStartEndDates,
} from '../actions/internalActions';
import getQuickComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getQuickComposeViewState';

mutator(setQuickComposeActivePivot, actionMessage => {
    let viewState = getQuickComposeViewState();
    viewState.activePivot = actionMessage.pivot;
});

mutator(updateCachedEventData, actionMessage => {
    let viewState = getQuickComposeViewState();
    const newEventData = { ...viewState.cachedEventData, ...actionMessage.data };
    viewState.cachedEventData = newEventData;
});

mutator(setQuickComposeEventBodyViewState, actionMessage => {
    let viewState = getQuickComposeViewState();
    viewState.bodyViewState = actionMessage.body;
});

mutator(updateOofStartEndDates, actionMessage => {
    const { startDate, endDate } = actionMessage;
    let { oofViewState } = getQuickComposeViewState();
    oofViewState.startDate = startDate;
    oofViewState.endDate = endDate;
});
